import { setApiAuthToken } from '@torlin/api-client';
import type { AuthTokenDetails } from '@torlin/api-client';

export const WEB_AUTH_TOKEN_KEY = 'torlin.neo.web.auth-token';
const WEB_AUTH_COOKIE = 'torlin_neo_web_token';
const WEB_AUTH_DETAILS_KEY = 'torlin.neo.web.auth-token-details';

export function saveWebAuthToken(token: string, days = 365, details?: AuthTokenDetails | null): void {
  localStorage.setItem(WEB_AUTH_TOKEN_KEY, token);
  if (details) localStorage.setItem(WEB_AUTH_DETAILS_KEY, JSON.stringify(details));
  else localStorage.setItem(WEB_AUTH_DETAILS_KEY, JSON.stringify({ created_at: new Date().toISOString(), expires_at: new Date(Date.now() + days * 86400000).toISOString(), ttl_days: days }));
  document.cookie = `${WEB_AUTH_COOKIE}=${encodeURIComponent(token)}; Max-Age=${days * 86400}; Path=/; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
  setApiAuthToken(token);
}

export function clearWebAuthToken(): void {
  localStorage.removeItem(WEB_AUTH_TOKEN_KEY);
  localStorage.removeItem(WEB_AUTH_DETAILS_KEY);
  document.cookie = `${WEB_AUTH_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`;
  setApiAuthToken(null);
}

export function readStoredWebAuthDetails(): AuthTokenDetails | null {
  try {
    const value = localStorage.getItem(WEB_AUTH_DETAILS_KEY);
    return value ? JSON.parse(value) as AuthTokenDetails : null;
  } catch { return null; }
}

export function restoreWebAuthToken(): string | null {
  const cookie = document.cookie.split('; ').find((item) => item.startsWith(`${WEB_AUTH_COOKIE}=`));
  const token = localStorage.getItem(WEB_AUTH_TOKEN_KEY) ?? (cookie ? decodeURIComponent(cookie.slice(`${WEB_AUTH_COOKIE}=`.length)) : null);
  if (token && !localStorage.getItem(WEB_AUTH_TOKEN_KEY)) localStorage.setItem(WEB_AUTH_TOKEN_KEY, token);
  setApiAuthToken(token);
  return token;
}
